(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/heart-background.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/heart-background.js');
"use strict";

const {
  useRef,
  useEffect
} = React;
const LovelyWorld = function (size, canvas) {
  this.gravity = [0.4, -4];
  this.size = size;
  this.update = () => {
    this.size = [canvas.width, canvas.height];
  };
  this.heartImages = ['triss-hjaerta-01.svg', 'triss-hjaerta-02.svg', 'triss-hjaerta-03.svg', 'triss-hjaerta-04.svg', 'triss-hjaerta-05.svg', 'triss-hjaerta-06.svg', 'triss-hjaerta-07.svg'].map(file => {
    const image = new Image();
    image.src = "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets/").concat(file);
    return image;
  });
  this.imageScale = 1 / 4.5;
  this.margin = 50;
};
const heartDrawObj = world => {
  const {
    size
  } = world;
  const position = [Math.floor(Math.random() * size[0]), Math.random() * size[1]];
  const mass = [0, 0.2];
  const seed = Math.random() * (Math.PI * 2);
  const scale = Math.random() * 0.8 + 0.7;
  const realLifeScale = 0.01 * scale * 5;
  const imageId = Math.ceil(Math.random() * 7);
  return {
    seed,
    position,
    mass,
    update: (obj, world, delta) => {
      const {
        gravity,
        size,
        margin
      } = world;
      const xOrigin = position[0];
      const oscillation = Math.sin(seed + delta / 3000 * scale) * 50;
      const newPos = seed + delta * gravity[0] * realLifeScale;
      const x = xOrigin + oscillation * 2 + newPos;
      const relativeX = x < -margin ? size[0] + margin * 2.5 - Math.abs(x) % size[0] : x % (size[0] + margin) - margin / 2;
      let y = (position[1] + delta * gravity[1] * mass[1] * realLifeScale) % size[1];
      if (y < 0) {
        y += size[1];
      }
      obj.position = [relativeX, y];
      obj.rotation = oscillation;
    },
    draw: (obj, ctx) => {
      const {
        heartImages,
        imageScale
      } = world;
      const {
        position,
        rotation
      } = obj;
      const [x, y] = position;
      const image = heartImages[imageId];
      if (!image) {
        return;
      }
      ctx.save();
      ctx.setTransform(imageScale * scale, 0, 0, imageScale * scale, x, y);
      ctx.rotate(rotation * Math.PI / 180);
      ctx.drawImage(image, -image.width / 2, -image.width / 2);
      ctx.restore();
    }
  };
};
setGlobal('svs.tickets.play.components.HeartBackground', () => {
  const containerRef = useRef();
  const canvasRef = useRef();
  useEffect(() => {
    const world = new LovelyWorld([window.innerWidth, window.innerHeight], canvasRef.current);
    const {
      destroy
    } = svs.tickets.play.utils.particleRenderer({
      drawObject: heartDrawObj,
      world,
      canvas: canvasRef.current,
      particlePerPixel: 0.00008
    });
    const onResize = _.debounce(() => {
      if (canvasRef.current) {
        canvasRef.current.height = window.innerHeight;
        canvasRef.current.width = window.innerWidth;
      }
    }, 500);
    addEventListener('resize', onResize);
    return () => {
      removeEventListener('resize', onResize);
      destroy();
    };
  }, []);
  return React.createElement("div", {
    className: "animated-background-container",
    ref: containerRef
  }, React.createElement("canvas", {
    height: window.innerHeight,
    ref: canvasRef,
    width: window.innerWidth
  }));
});

 })(window);